import { Fragment } from 'prosemirror-model';
export function mapChildren(node, callback) {
  const array = [];
  for (let i = 0; i < node.childCount; i += 1) {
    array.push(callback(node.child(i), i, node instanceof Fragment ? node : node.content));
  }
  return array;
}
export function flatmap(fragment, callback) {
  const fragmentContent = [];
  for (let i = 0; i < fragment.childCount; i += 1) {
    const child = callback(fragment.child(i), i, fragment);
    if (Array.isArray(child)) {
      fragmentContent.push(...child);
    } else {
      fragmentContent.push(child);
    }
  }
  return Fragment.fromArray(fragmentContent);
}
export const filter = (predicates, cmd) => (state, dispatch, view) => {
  let newPredicates = predicates;
  if (!Array.isArray(predicates)) {
    newPredicates = [predicates];
  }
  if (newPredicates.some(pred => !pred(state, view))) {
    return false;
  }
  return cmd(state, dispatch, view) || false;
};
export const getStepRange = transaction => {
  let from = -1;
  let to = -1;
  transaction.steps.forEach(step => {
    step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd) => {
      from = newStart < from || from === -1 ? newStart : from;
      to = newEnd < to || to === -1 ? newEnd : to;
    });
  });
  if (from !== -1) {
    return {
      from,
      to
    };
  }
  return null;
};
export function isEmptyDocument(node) {
  const nodeChild = node.content.firstChild;
  if (node.childCount !== 1 || !nodeChild) {
    return false;
  }
  return nodeChild.type.name === 'paragraph' && !nodeChild.childCount && nodeChild.nodeSize === 2 && (!nodeChild.marks || nodeChild.marks.length === 0);
}